// extracts the code and uniforms from a set of inlet arguments
// can then pass these to gl() to create a new gl object to be passed along
export const extractCode = (...args) => {
    let uniforms = {};
    let codes = [];

    for (let arg of args) {
        if (typeof arg === "function") {
            arg = arg();
        }
        arg = arg === undefined ? {} : arg;
        codes.push(arg.code || arg || "0.0");
    }

    return codes;
};

